import React, { memo, FC } from "react";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import { Image } from "cloudinary-react";
import findHingePlateImg from "./findHingePlateImg";
import InfoIcon from "@mui/icons-material/Info";
import { Typography } from "@mui/material";
import { RowLayout } from "../../util/accordianStyles";
import useHingeSelector from "./useHingeSelector";
import { normalHandleColor } from "../Handle/defaults";
import { hingeFritsDropseal } from "./defaults";
import { useIsReadOnlyContextProviderContext } from "../../context/IsReadOnlyContext";
import PleaseNote from "../PleaseNote";

const HingeAccordian: FC = () => {
  const {
    hingeOptions,
    heading,
    handleClick,
    pivotHardware,
    dropseal,
    variant,
    checkMark,
    doorType,
    hingeColor,
    stilesAndRails,
    hasSquareBarrelHinges,
    material,
    isAlumBifold,
  } = useHingeSelector();

  if (hasSquareBarrelHinges) return null;

  return (
    <ReusableAccordian
      accordionName="hinge"
      heading={heading}
      secondaryHeading={stilesAndRails?.includes("Pico") ? "Select exterior hinge color" : "Select hinge color"}
      colOrRow="col"
    >
      {doorType === "Pivot" && (
        <RowLayout style={{ paddingBottom: 20 }}>
          <PleaseNote
            notes="The hinge plate is positioned at the pivot axis point between the
            door's bottom and the sill."
          />
        </RowLayout>
      )}

      {stilesAndRails?.includes("Pico") && (
        <RowLayout style={{ paddingBottom: 20 }}>
          <PleaseNote notes={"Interior concealed hinges are always Black"} />
        </RowLayout>
      )}

      <RowLayout>
        {material === "All Aluminum" && !isAlumBifold ? (
          normalHandleColor.map((state) => (
            <div key={state} onClick={() => handleClick(state)}>
              <Choices
                label={state}
                variant={variant(state)}
                checkMark={checkMark(state)}
                wide={true}
              />
            </div>
          ))
        ) : pivotHardware === "Fritsjurgens" && dropseal ? (
          <div>
            <Choices
              label={hingeFritsDropseal.label}
              variant="filled"
              checkMark={true}
              wide={true}
            />
          </div>
        ) : (
          hingeOptions.map((state) => (
            <div
              key={state.id}
              onClick={() => (state.disabled ? null : handleClick(state.label))}
            >
              <Choices
                label={state.label}
                variant={variant(state.label)}
                checkMark={checkMark(state.label)}
                wide={true}
                disabled={state.disabled}
              />
            </div>
          ))
        )}
      </RowLayout>

      {hingeColor && pivotHardware && (
        <Image
          cloudName="ag-millworks"
          secure="true"
          publicId={findHingePlateImg(
            pivotHardware,
            hingeColor,
            dropseal || "",
          )}
        />
      )}
    </ReusableAccordian>
  );
};

export default memo(HingeAccordian);
